<a href="https://mytidy.it" class="text-center" style="display:block; color: black; font-weight: bold; font-size: 12px;">
    <span style="padding-top: 2px; vertical-align: sub">Powered by&nbsp;</span><img width="32" height="32" src="/assets/images/mytidy.png">
</a>

<div class="text-center" style="margin: 30px;">
    <a routerLink="/">
        <div>
            <img *ngIf="store.logo" [src]="store.logo" class="azienda-logo-icon-large">
        </div>
        <div *ngIf="!store.logo" style="font-size: 24px; font-weight: 700; color: black">{{store.name}}</div>
    </a>
</div>